import { Link, useNavigate } from "react-router-dom";
import { FiHome } from "react-icons/fi";
import { IoStorefrontOutline } from "react-icons/io5";
import { PiChatTeardropTextLight } from "react-icons/pi";
import React from "react";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { CiUser } from "react-icons/ci";

type LeftNavProps = {
  user: any;
  isRefetching?: () => void;
  _profileImage?: string;
};
const LeftNav: React.FC<Partial<LeftNavProps>> = ({
  user,
  _profileImage,
}) => {
  // const [isOpen, setIsOpen] = React.useState(false);
  const add = "+ad4e_nj";
  const navigate = useNavigate();

  React.useMemo(() => {
    if (user.id === null) {
      navigate("/auth");
    } 
    // else {
    //   idRef.current = `${user.id}${add}`;
    // }
  }, [navigate, user]);

  return (
    <div className="hidden w-[18%] lg:flex bg-white shadow-sm h-fit rounded sticky top-32 px-9 py-12">
      <ul className="flex justify-center justify-items-center flex-col font-SegoeUI font-normal text-sm gap-7">
        <li>
          <Link to="/ecobook" className="gap-3 flex text-center items-center">
            <FiHome size={21} className="text-[#222222]" />
            <h1>Home</h1>
          </Link>
        </li>
        <li>
          <Link
            to="/ecobook/my-communities"
            className="flex gap-3 items-center text-center"
          >
            <IoStorefrontOutline size={21} className="text-[#222222]" />
            <h1>Discover</h1>
          </Link>
        </li>
        <li>
          <Link
            to="/chat/e"
            className="ml-[-2px] flex gap-3 items-center text-center"
          >
            <PiChatTeardropTextLight size={22} />
            <h1>Chats</h1>
          </Link>
        </li>
        {/* <li className="flex gap-3 text-center">
          <BsPlusSquare  size={18}/>
          <h1>Create</h1>
        </li> */}
        {/* <li className="gap-3 flex items-center">
          <BsHeart size={18} className="fill-[#222222]"/>
          <h1>Notifications</h1>
        </li> */}
        <li>
          <Link
            to={`/ecobook/profile/${user.id}${add}`}
            className="flex gap-3 items-center text-center"
          >
            {_profileImage ? (
              <img
                alt=""
                src={ipfsGatewayImage(_profileImage!)}
                className="rounded-full w-[22px] h-[22px]"
              />
            ) : (
              <div className="w-5 h-5 bg-slate-100 flex items-center justify-center rounded-full">
                <CiUser size={15} />
              </div>
            )}
            <h1>Profile</h1>
          </Link>
        </li>
        <div
          className="flex gap-3 items-center text-center mt-14 relative cursor-pointer"
          // onClick={() => setIsOpen(!isOpen)}
        >
          {/* <img src={moreIcon} alt="" />
          <h1>More</h1>
          {isOpen && (
            <div
              className="absolute bg-white shadow-md p-4 right-11 flex items-center justify-center font-Poppins font-medium text-sm rounded w-[180px] "
              onClick={() => setopenCreate(true)}
            >
              Create a community
            </div>
          )} */}
        </div>
      </ul>
    </div>
  );
};

export default LeftNav;
